import React, { cloneElement, useEffect, useRef, useState, } from 'react';
import { createPortal } from 'react-dom';
import { EVENT_NAME_MAP } from '@yme/utils/constants';
import { getDynamicTooltipStyles, getTooltipStyles } from './helpers';
import { TooltipStyled } from './styled';
import { TooltipPlacement, TooltipState } from './types';
export function Tooltip({ children, title, hasEnableHoverListener = true, hasEnableClickListener = false, placement = TooltipPlacement.ABOVE_CENTER, state = TooltipState.DEFAULT, outerDynamicLeftCoord, isHeaderStickyMenuShown, }) {
    const [isOpen, setIsOpen] = useState(false);
    const [tooltipStyles, setTooltipStyles] = useState({});
    const [anchorElement, setAnchorElement] = useState();
    const refTooltip = useRef(null);
    const closeTooltip = () => {
        setIsOpen(false);
        setTooltipStyles({});
    };
    useEffect(() => {
        const handle = (event) => {
            if (!hasEnableClickListener ||
                refTooltip.current?.contains(event.target) ||
                !anchorElement ||
                anchorElement.contains(event.target)) {
                return;
            }
            closeTooltip();
        };
        document.addEventListener(EVENT_NAME_MAP.click, handle);
        return () => {
            document.removeEventListener(EVENT_NAME_MAP.click, handle);
        };
    }, [hasEnableClickListener, anchorElement]);
    useEffect(() => {
        if (isHeaderStickyMenuShown === undefined || !isOpen || !anchorElement)
            return;
        setTooltipStyles(getTooltipStyles(anchorElement, placement));
    }, [anchorElement, isHeaderStickyMenuShown, isOpen, placement]);
    const handleMouseEnter = (event) => {
        if (children.props.onMouseEnter) {
            children.props.onMouseEnter(event);
        }
        if (hasEnableHoverListener) {
            setIsOpen(true);
            setTooltipStyles(getTooltipStyles(event.currentTarget, placement));
        }
    };
    const handleMouseLeave = (event) => {
        if (children.props.onMouseLeave) {
            children.props.onMouseLeave(event);
        }
        if (hasEnableHoverListener) {
            closeTooltip();
        }
    };
    const handleClick = (event) => {
        if (children.props.onClick) {
            children.props.onClick(event);
        }
        if (hasEnableClickListener) {
            setIsOpen(true);
            setTooltipStyles(getTooltipStyles(event.currentTarget, placement));
            setAnchorElement(event.currentTarget);
        }
    };
    const dynamicToolTipStyles = getDynamicTooltipStyles(tooltipStyles, outerDynamicLeftCoord);
    const childrenProps = {
        onPointerEnter: handleMouseEnter,
        onPointerLeave: handleMouseLeave,
        onClick: handleClick,
    };
    if (hasEnableClickListener) {
        childrenProps.isActive = isOpen;
    }
    return (React.createElement(React.Fragment, null,
        cloneElement(children, childrenProps),
        isOpen &&
            createPortal(React.createElement(TooltipStyled, { role: "tooltip", placement: placement, state: state, style: {
                    ...dynamicToolTipStyles,
                }, ref: refTooltip }, title), document.body)));
}
